import React, { useState, useEffect, Component } from 'react';
import { connect } from "react-redux";

import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, SwipeableDrawer, Grow, CircularProgress, List, ListItem, ListItemText, IconButton
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { ChevronRight } from '@material-ui/icons';

import { setLoginModalOpened, login, setRegisterModalOpened, setResetPasswordModalOpened } from './../../actions/users.actions';
import { addErrorMessages, addSuccessMessage } from './../../../messages/messages.actions';
import { styles } from './../../styles/loginModal.css'
import LoginForm from './LoginForm';
import addNotification from 'react-push-notification';
import MessagesContainer from '../../../messages/MessagesContainer';
import Auth from '../../../utils/Auth';

class LoginModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            rememberMe: 0
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (!!this.state.email && !!this.state.password) {
            this.props.login(this.state)
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onChangeCheckbox = (e) => {
        this.setState({ [e.target.name]: e.target.checked });
    }

    goToRegister = () => {
        this.props.setLoginModalOpened(false);
        this.props.setRegisterModalOpened(true);
    }

    goToResetPassword = () => {
        this.props.setLoginModalOpened(false);
        this.props.setResetPasswordModalOpened(true);
    }


    showNotification = () => {
        //console.log("VISIBI", document.visibilityState)
        // if(document.visibilityState === "visible") {
        //     return;
        // }
        var title = "JavaScript Jeep";
        var icon = "image-url"
        var body = "Message to be displayed";
        var notification = new Notification('Title', { body, icon });
        notification.onclick = () => {
            notification.close();
            window.parent.focus();
        }
    }

    requestAndShowPermission = () => {
        Notification.requestPermission(function (permission) {
            if (permission === "granted") {
                this.showNotification();
            }
        });
    }

    notify = () => {

        // let permission = Notification.permission;
        // console.log("permission", permission)
        // if(permission === "granted") {
        //     this.showNotification();
        // } else if(permission === "default"){
        //     this.requestAndShowPermission();
        // } else {
        //   alert("Use normal alert");
        // }
        navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/notification_sw.js`);
        Notification.requestPermission(function (result) {
            console.log("requesting")

            if (result === 'granted') {
                console.log("granted")

                navigator.serviceWorker.ready.then(function (registration) {
                    console.log("SHOW NOTIF", registration)
                    registration.showNotification('Notification with ServiceWorker');
                });
            }
        });

    }

    render() {
        const { classes, fullWidth = true, maxWidth = 'xs', open, handleClose, translations, allProducts } = this.props;

        let isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
            || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)


        return (
            <React.Fragment>
                <SwipeableDrawer
                    open={this.props.loginModalOpened}
                    anchor={'right'}
                    onClose={() => this.props.setLoginModalOpened(false)}
                    onOpen={() => this.props.setLoginModalOpened(true)}
                    aria-labelledby="max-width-dialog-title"
                    data-class="dialog-container"
                    className={classes.root}
                    disableSwipeToOpen
                    swipeAreaWidth={0}
                >

                    {isIOS ? <MessagesContainer /> : null}

                    {/* <button onClick={this.notify}>NOTIFY</button> */}

                    <DialogTitle id="max-width-dialog-title" className={classes.modalTitle} data-class="dialog-title-container">
                        <IconButton onClick={() => this.props.setLoginModalOpened(false)} className={classes.closeDrawerButton}>
                            <ChevronRight />
                        </IconButton>

                        <div>
                            {translations && translations.login && translations.login.log_in_your_profile}
                            {/* Влез в профила си */}
                            <div style={{ fontSize: 16 }}>
                                {/* и запази своите данни */}
                                {translations && translations.login && translations.login.save_your_data}
                            </div>
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText>
                            <LoginForm
                                state={this.state}
                                handleChange={this.handleChange}
                                onChangeCheckbox={this.onChangeCheckbox}
                                onSubmit={this.onSubmit}
                                translations={this.props.translations}
                                addErrorMessages={this.props.addErrorMessages}
                                addSuccessMessage={this.props.addSuccessMessage}
                            />

                            <List>
                                <ListItem button onClick={this.goToRegister} className={classes.goToRegister}>
                                    <ListItemText primary={translations && translations.login && translations.login.register_if_no_profile /*'Нямаш профил? Регистрирай се'*/} />
                                </ListItem>
                                <ListItem button onClick={this.goToResetPassword} className={classes.goToRegister}>
                                    <ListItemText primary={translations && translations.login && translations.login.forgot_password /*'Забравил си паролата си?'*/} />
                                </ListItem>
                            </List>
                        </DialogContentText>
                    </DialogContent>

                </SwipeableDrawer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        translations: state.lang.translations || [],
        loginModalOpened: state.users.login_modal_opened || false
    };
};

export default withStyles(styles)(connect(mapStateToProps, {
    setLoginModalOpened, login, setRegisterModalOpened, addErrorMessages,
    addSuccessMessage, setResetPasswordModalOpened
})(LoginModal))